import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Section } from './Section';
import { faqItems } from '../data/faq';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section tone="ivory" data-id="element-96" data-mp="1gcxsapvh5c2f">
      <h2 className="text-center font-serif text-[28px] leading-tight sm:text-4xl" data-id="element-97" data-mp="1gdqoiwwt4j6b">
        Preguntas, respondidas
      </h2>

      <ul className="mx-auto mt-12 max-w-[760px] flex flex-col gap-3" data-id="element-98" data-mp="2dzoe1e9ltorr">
        {faqItems.map((item, index) => {
        const isOpen = open === index;
        return <li key={item.question} className="card-editorial overflow-hidden" data-id="element-99" data-mp="240yulh227w9e" data-mpi={index}>
              <h3 data-id="element-100" data-mp="1z3yox794gvit">
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" data-id="element-101" data-mp="1z2ds1azc50hs">
                  <span className="text-[15px] font-medium sm:text-base" data-id="element-102" data-mp="ufpt8e1bhny3">
                    {item.question}
                  </span>
                  {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-103" data-mp="kil7gfbdvuht" /> : <PlusIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-104" data-mp="6plscefik2as" />}
                </button>
              </h3>

              <AnimatePresence initial={false} data-id="element-105" data-mp="1s3o31cfyb94">
                {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.26,
              ease: [0.22, 1, 0.36, 1]
            }} className="overflow-hidden" data-id="element-106" data-mp="1q0obplhl3r7">
                    <p className="border-t border-gold-line px-6 py-5 text-[15px] leading-relaxed text-ink-soft" data-id="element-107" data-mp="1pob8oy9utel8">
                      {item.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </li>;
      })}
      </ul>
    </Section>;
}